function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, useEffect, useState } from 'react';
import { CalendarView, ICalendarPosition } from '../View/CalendarView';
import { ICalendarDate, ICalendarProps } from '../Calendar';
import { incrementDateByMonths, isDateBGreaterThanDateA, today } from '../helpers/dateFormatters';
import { useDoubleCalendar } from './useDoubleCalendar';
import { validateRangeDates } from '../helpers/validators';
export const DoubleCalendar = props => {
  const {
    selectedDateOne,
    selectedDateTwo,
    onClickDate,
    onCheck,
    dateFormat = 'YYYY.MM.DD'
  } = props;
  const isValid = validateRangeDates(selectedDateOne, selectedDateTwo);
  const defaultViewArgs = selectedDateOne && selectedDateTwo && isValid ? [selectedDateOne, selectedDateTwo] : [today, incrementDateByMonths(today, 1)];
  const {
    currentViewStateOne,
    currentViewStateTwo,
    handleChangeViewYearOne,
    handleChangeViewYearTwo,
    handleIncrementMonthIndexOne,
    handleIncrementMonthIndexTwo,
    handleDecrementMonthIndexOne,
    handleDecrementMonthIndexTwo,
    setDoubleViewState
  } = useDoubleCalendar(...defaultViewArgs);
  useEffect(() => {
    if (selectedDateOne && selectedDateTwo && (selectedDateOne.year !== selectedDateTwo.year || selectedDateOne.monthIndex !== selectedDateTwo.monthIndex)) {
      if (selectedDateOne.year !== currentViewStateOne.year || selectedDateOne.monthIndex !== currentViewStateOne.monthIndex) {
        setDoubleViewState(prev => ({
          ...prev,
          viewStateOne: {
            year: selectedDateOne.year,
            monthIndex: selectedDateOne.monthIndex
          }
        }));
      }
      if (selectedDateTwo.year !== currentViewStateTwo.year || selectedDateTwo.monthIndex !== currentViewStateTwo.monthIndex) {
        setDoubleViewState(prev => ({
          ...prev,
          viewStateTwo: {
            year: selectedDateTwo.year,
            monthIndex: selectedDateTwo.monthIndex
          }
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDateOne, selectedDateTwo, setDoubleViewState]);
  const [isChoosingDateOne, setIsChoosingDateOne] = useState(true);
  const handleCheck = useCallback(value => {
    if (!value && isChoosingDateOne) {
      onCheck?.(undefined, selectedDateTwo);
      return;
    }
    if (!value && !isChoosingDateOne) {
      onCheck?.(selectedDateOne);
      return;
    }
    if (!selectedDateOne && !selectedDateTwo) {
      onCheck?.(value);
      setIsChoosingDateOne(!value);
      return;
    }
    if (isChoosingDateOne && (!selectedDateTwo || isDateBGreaterThanDateA(value, selectedDateTwo))) {
      setIsChoosingDateOne(false);
      onCheck?.(value, selectedDateTwo);
      return;
    }
    if (isChoosingDateOne && selectedDateTwo && isDateBGreaterThanDateA(selectedDateTwo, value)) {
      onCheck?.(selectedDateTwo, value);
      return;
    }
    if (!isChoosingDateOne && (!selectedDateOne || isDateBGreaterThanDateA(selectedDateOne, value))) {
      setIsChoosingDateOne(true);
      onCheck?.(selectedDateOne, value);
      return;
    }
    if (!isChoosingDateOne && selectedDateOne && isDateBGreaterThanDateA(value, selectedDateOne)) {
      onCheck?.(value, selectedDateOne);
      return;
    }
  }, [isChoosingDateOne, selectedDateOne, selectedDateTwo, onCheck]);
  const handleClickDate = useCallback(e => {
    const {
      calendarPosition,
      ...clickedDate
    } = JSON.parse(e.target.value);
    onClickDate && onClickDate(clickedDate);
    handleCheck(clickedDate);
    setDoubleViewState(prev => {
      if (calendarPosition === 'primary' && prev.viewStateOne.year !== clickedDate.year || calendarPosition === 'primary' && prev.viewStateOne.monthIndex !== clickedDate.monthIndex) {
        return {
          ...prev,
          viewStateOne: {
            year: clickedDate.year,
            monthIndex: clickedDate.monthIndex
          }
        };
      }
      if (calendarPosition === 'secondary' && prev.viewStateTwo.year !== clickedDate.year || calendarPosition === 'secondary' && prev.viewStateTwo.monthIndex !== clickedDate.monthIndex) {
        return {
          ...prev,
          viewStateTwo: {
            year: clickedDate.year,
            monthIndex: clickedDate.monthIndex
          }
        };
      }
      return prev;
    });
  }, [onClickDate, setDoubleViewState, handleCheck]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CalendarView, _extends({}, props, {
    currentView: currentViewStateOne,
    onIncrementMonthIndex: handleIncrementMonthIndexOne,
    onDecrementMonthIndex: handleDecrementMonthIndexOne,
    onChangeViewYear: handleChangeViewYearOne,
    onClickDate: handleClickDate,
    position: "primary",
    selectedDateOne: selectedDateOne,
    selectedDateTwo: selectedDateTwo,
    dateFormat: dateFormat
  })), /*#__PURE__*/React.createElement(CalendarView, _extends({}, props, {
    currentView: currentViewStateTwo,
    onIncrementMonthIndex: handleIncrementMonthIndexTwo,
    onDecrementMonthIndex: handleDecrementMonthIndexTwo,
    onChangeViewYear: handleChangeViewYearTwo,
    onClickDate: handleClickDate,
    position: "secondary",
    selectedDateOne: selectedDateOne,
    selectedDateTwo: selectedDateTwo,
    dateFormat: dateFormat
  })));
};